import { render, staticRenderFns } from "./EudrForestCover2020.vue?vue&type=template&id=6085b709&lang=pug"
import script from "./EudrForestCover2020.vue?vue&type=script&lang=js"
export * from "./EudrForestCover2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports